<template>
    <v-col cols="12" class="d-flex">
        <v-hover v-slot="{ hover }">
            <v-card 
                :elevation="hover ? 12 : 2"
                :class="{ 'on-hover': hover }"
                style="display: flex;background-color: #1976d2;margin: 10px;min-width: 200px;min-height: 100px;" 
                max-width="200px" 
                outlined 
                shaped 
                elevation="2"
            >
                <slot name="content">
                </slot>
                
                <template v-if="hover">
                    <v-overlay absolute opacity="0.8" color="black">
                        <div class="d-flex flex-column align-center">
                        <v-btn :loading="loading" color="primary" class="mb-2" @click="() => view()">
                            <v-icon v-if="!loading">mdi-eye-outline</v-icon>
                        </v-btn>
                        <v-btn :disabled="loading" color="error" @click="deleteItem()">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        </div>
                    </v-overlay>
                </template>

            </v-card>
        </v-hover>
    </v-col>
</template>
  
<script>
import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper";
export default {
    name: "CardsCheckList",
    
    components: {
        
    },
    
    props: {
        // item: {
        //     type: Object,
        //     default: () => ({})
        // },
        view: {
            type: Function,
            default: () => {}
        },
        remove: {
            type: Function,
            default: () => {}
        },
        loading: {
            type: Boolean,
            default: false
        },
        // itemImage: {
        //     type: String,
        //     required: true,
        // },
    },
    
    data: () => ({
        cards: [],
    }),

    computed: {

    },

    methods: {
        deleteItem() {
            showDeleteDialogAlert(
                "Tem certeza que deseja excluir este item?",
                this.remove
            );
        },
    },

    watch: {
        list: {
            immediate: true,
            handler: function (newValue) {
                if (Array.isArray(newValue)) {
                    newValue.forEach(
                        (item) => {
                            if (!item.hasOwnProperty(this.itemImage)) {
                                throw new Error(`Não foi encontrado a chave da imagem: ${this.itemImage}`);
                            }
                        }
                    )

                }
            }
        },
    },

};
</script>
  
<style scoped>
.no-margin {
    margin: 0;
}
.d-flex {
    display: flex;
}
.f-align-center {
    align-items: center;
}
.f-1 {
    flex: 1;
}
.f-2 {
    flex: 2;
}

.v-card {
    transition: opacity .4s ease-in-out;
}
  

</style>